@if (loading()) {
  <div class="h-full flex align-items-center justify-content-center m-4">
    <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
  </div>
} @else {
  @if (form) {
    <div [formGroup]="form" class="modalForm">
      <!-- Form Fields for Gate System: -->
      <div class="flex flex-column justify-content-end gap-2 mb-3">
        <label for="label" class="font-semibold">{{ "gate_administration.gate_system_form.label" | translate }}*</label>
        <input pInputText id="label" formControlName="label" autocomplete="off" />
      </div>
      <div class="flex flex-column justify-content-end gap-2 mb-3">
        <label for="core" class="font-semibold">{{ "gate_administration.gate_system_form.core" | translate }}</label>
        <p-select
          id="core"
          formControlName="core"
          [options]="options.yesNo"
          (onChange)="onCoreChange($event)"
          class="w-full"
        />
      </div>
      @if (form.get("core")?.value) {
        <div class="flex flex-column justify-content-end gap-2 mb-3">
          <label for="coreId" class="font-semibold"
            >{{ "gate_administration.gate_system_form.coreId" | translate }}*</label
          >
          <!-- For unknown reasons this select is not showing the value when disabled, so using an input in those cases-->
          <p-select
            *appHasPermission="{
              permissions: [
                permissions.allPermissions.ASSET_MASTER_DATA_UPDATE,
                permissions.allPermissions.ASSET_MASTER_DATA_CREATE,
              ],
            }"
            id="coreId"
            appendTo="body"
            [options]="allCores"
            optionLabel="serialNumber"
            optionValue="id"
            [filter]="true"
            filterMatchMode="contains"
            [emptyFilterMessage]="translate.instant('common.no_results_found')"
            [emptyMessage]="translate.instant('common.no_results_found')"
            filterBy="serialNumber"
            showClear="true"
            formControlName="coreId"
            class="w-full"
          />

          <input
            *appHasPermission="{
              permissions: [permissions.allPermissions.ASSET_MASTER_DATA_READ],
              missingPermission: permissions.allPermissions.ASSET_MASTER_DATA_CREATE,
            }"
            pInputText
            id="coreId"
            formControlName="coreId"
            autocomplete="off"
            readonly
          />
        </div>
      }
      @if (gateSystem.building?.buildingFloorMapUrl) {
        <div style="grid-column: 1 / 3" class="flex flex-column justify-content-end gap-2 mb-3 floorMapContainer">
          <label for="floorMap" class="font-semibold">{{
            "gate_administration.gate_system_form.position_in_building" | translate
          }}</label>
          <div class="floorMap" (click)="onImageClick($event)">
            <img [src]="floorMapSource" id="buildingFloorMap" alt="Floor Map" (load)="onImageLoad($event)" />
            @if (point()) {
              <div class="point" [ngStyle]="getPointCoordinates()"></div>
            }
          </div>
        </div>
      }
      <div class="flex flex-column justify-content-end gap-2 mb-3">
        <label for="gateNumber" class="font-semibold">{{
          "gate_administration.gate_system_form.gateNumber" | translate
        }}</label>
        <input pInputText id="gateNumber" formControlName="gateNumber" autocomplete="off" />
      </div>

      <div class="flex flex-column justify-content-end gap-2 mb-3">
        <label for="retailerNumber" class="font-semibold">{{
          "gate_administration.gate_system_form.retailerNumber" | translate
        }}</label>
        <input pInputText id="retailerNumber" formControlName="retailerNumber" autocomplete="off" />
      </div>
      <div class="flex flex-column justify-content-end gap-2 mb-3">
        <label for="gateType" class="font-semibold">{{
          "gate_administration.gate_system_form.gateType" | translate
        }}</label>
        @if (gateTypes) {
          <p-select id="gateType" formControlName="gateType" [options]="gateTypes" optionValue="id" class="w-full">
            <ng-template let-gateType #selectedItem>
              {{ "gate_administration.gate_system_form.gate_types." + gateType.label | translate }}
            </ng-template>
            <ng-template let-gateType #item>
              {{ "gate_administration.gate_system_form.gate_types." + gateType.label | translate }}
            </ng-template>
          </p-select>
        }
      </div>
      <div class="flex flex-column justify-content-end gap-2 mb-3">
        <label for="personalDoor" class="font-semibold"
          >{{ "gate_administration.gate_system_form.personalDoor" | translate }}*</label
        >
        <p-select id="personalDoor" formControlName="personalDoor" [options]="options.yesNo" class="w-full" />
      </div>
      <div class="flex flex-column justify-content-end gap-2 mb-3">
        <label for="gateManufacturer" class="font-semibold">{{
          "gate_administration.gate_system_form.gateManufacturer" | translate
        }}</label>
        <input pInputText id="gateManufacturer" formControlName="gateManufacturer" autocomplete="off" />
      </div>
      <div class="flex flex-column justify-content-end gap-2 mb-3">
        <label for="gateMake" class="font-semibold">{{
          "gate_administration.gate_system_form.gateMake" | translate
        }}</label>
        <input pInputText id="gateMake" formControlName="gateMake" autocomplete="off" />
      </div>

      @if (form.get("core")?.value) {
        <div class="flex flex-column justify-content-end gap-2 mb-3">
          <label for="gateHistoryCycle" class="font-semibold"
            >{{ "gate_administration.gate_system_form.gateHistoryCycle" | translate }}*</label
          >
          <p-inputNumber id="gateHistoryCycle" formControlName="gateHistoryCycle" class="w-full" />
        </div>
      }
      <div class="flex flex-column justify-content-end gap-2 mb-3">
        <label for="activeDate" class="font-semibold"
          >{{ "gate_administration.gate_system_form.activeDate" | translate }}*</label
        >
        <p-datePicker
          [iconDisplay]="'input'"
          [showIcon]="true"
          [showWeek]="true"
          [firstDayOfWeek]="1"
          id="activeDate"
          formControlName="activeDate"
          dateFormat="dd.mm.yy"
          inputStyleClass="w-full"
          appendTo="body"
        />
      </div>

      <div class="flex flex-column justify-content-end gap-2 mb-3" style="grid-column: 1">
        <label for="width" class="font-semibold">{{ "gate_administration.gate_system_form.width" | translate }}*</label>
        <p-inputNumber id="width" formControlName="width" class="w-full" />
      </div>

      <div class="flex flex-column justify-content-end gap-2 mb-3">
        <label for="height" class="font-semibold"
          >{{ "gate_administration.gate_system_form.height" | translate }}*</label
        >
        <p-inputNumber id="height" formControlName="height" class="w-full" />
      </div>
      @if (form.get("core")?.value) {
        <div class="flex flex-column justify-content-end gap-2 mb-3">
          <label for="controlManufacturer" class="font-semibold"
            >{{ "gate_administration.gate_system_form.controllerManufacturer" | translate }}*</label
          >
          <p-select
            appendTo="body"
            [options]="allControllerManufacturers()"
            formControlName="controlManufacturer"
            class="w-full"
            id="controlManufacturer"
            (onChange)="onControllerManufacturerSelected($event)"
            [filter]="true"
            filterMatchMode="contains"
            dataKey="id"
            [emptyFilterMessage]="translate.instant('common.no_results_found')"
          >
          </p-select>
        </div>

        <div class="flex flex-column justify-content-end gap-2 mb-3">
          <label for="controlModel" class="font-semibold"
            >{{ "gate_administration.gate_system_form.controllerModel" | translate }}*</label
          >
          <p-select
            appendTo="body"
            [options]="allControllerModels()"
            formControlName="controlModel"
            class="w-full"
            id="controlModel"
            [filter]="true"
            filterMatchMode="contains"
            dataKey="id"
            [emptyFilterMessage]="translate.instant('common.no_results_found')"
          >
          </p-select>
        </div>
        <div class="flex flex-column justify-content-end gap-2 mb-3">
          <label for="hasButler" class="font-semibold">{{
            "gate_administration.gate_system_form.hasButler" | translate
          }}</label>
          <p-select id="hasButler" formControlName="hasButler" [options]="options.yesNo" class="w-full" />
        </div>
        <div class="flex flex-column justify-content-end gap-2 mb-3">
          <label for="hasGuard" class="font-semibold"
            >{{ "gate_administration.gate_system_form.hasGuard" | translate }}*</label
          >
          <p-select id="hasGuard" formControlName="hasGuard" [options]="options.yesNo" class="w-full" />
        </div>

        <div class="flex flex-column justify-content-end gap-2 mb-3">
          <label for="isSluiceGate" class="font-semibold"
            >{{ "gate_administration.gate_system_form.isSluiceGate" | translate }}*</label
          >
          <p-select id="isSluiceGate" formControlName="isSluiceGate" [options]="options.yesNo" class="w-full" />
        </div>
        <div class="flex flex-column justify-content-end gap-2 mb-3">
          <label for="quickupGate" class="font-semibold"
            >{{ "gate_administration.gate_system_form.quickupGate" | translate }}*</label
          >
          <p-select
            id="quickupGate"
            formControlName="quickupGate"
            [options]="options.noneStandardThermo"
            class="w-full"
          />
        </div>
        <div class="flex flex-column justify-content-end gap-2 mb-3">
          <label for="loadingBridge" class="font-semibold"
            >{{ "gate_administration.gate_system_form.loadingBridge" | translate }}*</label
          >
          <p-select
            id="loadingBridge"
            formControlName="loadingBridge"
            [options]="options.noneStandardThermo"
            class="w-full"
          />
        </div>
      }
      @if (form.get("hasGuard")?.value && form.get("core")?.value) {
        <div class="flex flex-column justify-content-end gap-2 mb-3">
          <label for="tempOffset" class="font-semibold">{{
            "gate_administration.gate_system_form.tempOffset" | translate
          }}</label>
          <p-inputNumber
            id="tempOffset"
            formControlName="tempOffset"
            class="w-full"
            mode="decimal"
            [minFractionDigits]="0"
            [maxFractionDigits]="3"
          />
        </div>
        <div class="flex flex-column justify-content-end gap-2 mb-3">
          <label for="expectedEnergyLossPerYear" class="font-semibold">{{
            "gate_administration.gate_system_form.expectedEnergyLossPerYear" | translate
          }}</label>
          <p-inputNumber id="expectedEnergyLossPerYear" formControlName="expectedEnergyLossPerYear" class="w-full" />
        </div>

        <div class="flex flex-column justify-content-end gap-2 mb-3">
          <label for="normalOperationThreshold" class="font-semibold">{{
            "gate_administration.gate_system_form.normalOperationThreshold" | translate
          }}</label>
          <p-inputNumber
            id="normalOperationThreshold"
            formControlName="normalOperationThreshold"
            class="w-full"
            [min]="0"
          />
        </div>

        <div class="flex flex-column justify-content-end gap-2 mb-3">
          <label for="emailEnergyLoss" class="font-semibold">{{
            "gate_administration.gate_system_form.emailEnergyLoss" | translate
          }}</label>
          <p-select id="emailEnergyLoss" formControlName="emailEnergyLoss" [options]="options.yesNo" class="w-full" />
        </div>
      }
      <!-- Buttons: -->
      <div class="flex justify-content-end gap-2 dialogBtnGroup">
        <app-button
          id="cancelGateButton"
          [buttonText]="translate.instant('common.cancel')"
          (click)="closeDialog()"
        ></app-button>
        <app-button
          id="saveGateSystemButton"
          [buttonText]="translate.instant('common.save')"
          [disabled]="!form.valid || requestStarted()"
          (click)="save()"
          [loading]="loading()"
        ></app-button>
      </div>
    </div>
  }
}
